import { generatePageNav } from './terms.js'

export default {
	init() {
      // handleDynamicNavGeneration()
      generatePageNav()
		
      // handleDualScrolling()
      
	},
	finalize() {
      // JavaScript to be fired on the home page, after the init JS
	},
}

function handleDynamicNavGeneration() {
   $('.single-pillars__nav__button').on('click', function() {
      this.closest('.single-pillars__nav').classList.toggle('single-pillars__nav--open')
   })

   //if click outside of nav, close it
   $(document).on('click', function(event) {
      if (!$(event.target).closest('.single-pillars__nav').length) {
         if ($('.single-pillars__nav').hasClass('single-pillars__nav--open')) {
            $('.single-pillars__nav').removeClass('single-pillars__nav--open')
         }
      }
   })

   //grab all h2s from the page
   let h2s = document.querySelectorAll('.single-pillars-pages__content h2')

   //for each h2, create a new anchor link wrapped inside a list item
   const singlePillarsNavUnorderedList = document.querySelector('.single-pillars__nav__ul')
   h2s.forEach((h2, index) => {
      if( ! h2.textContent ) { //empty string
         return
      }

      //check h2 for ID
      let elementID = h2.id
      //if empty, set to h2 text content
      if (elementID === '') {
         elementID = h2.textContent.toLowerCase().replace(/\s/g, '-')
      }
      //update h2 ID to match the href
      h2.id = elementID
      let li = document.createElement('li')
      //set class of li to .single-pillar__nav__li
      li.classList.add('single-pillar__nav__li')
      let a = document.createElement('a')
      //set the href to the h2 inner text, processed to be lowercase and with spaces replaced with hyphens
      a.href = '#' + elementID
      a.textContent = h2.textContent
      li.appendChild(a)
      singlePillarsNavUnorderedList.appendChild(li)
   })

   /*
      for all newly created links, on click, update .single-pillars__nav__button 
      span with the clicked link text and remove the open class from the nav
   */
   let navLinks = document.querySelectorAll('.single-pillar__nav__li a')
   navLinks.forEach((link) => {
      link.addEventListener('click', function() {
         //remove active class from all links
         navLinks.forEach((link) => {
            link.classList.remove('active')
         })
         //add active class to clicked link
         this.classList.add('active')
         document.querySelector('.single-pillars__nav__button span').textContent = this.textContent
         document.querySelector('.single-pillars__nav').classList.remove('single-pillars__nav--open')
      })
   })
}

function handleDualScrolling() {

   const stickyElement = document.querySelector('.single-pillar-pages__nav')
   let lastScrollTop = 0
   let stickyScrollTop = 0

   function handleDualScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop

      if (st > lastScrollTop) {
         // Scrolling down
         if (
            stickyScrollTop <
            stickyElement.scrollHeight - stickyElement.clientHeight
         ) {
            stickyElement.scrollTop = stickyScrollTop += st - lastScrollTop
         }
      } else {
         // Scrolling up
         if (stickyScrollTop > 0) {
            stickyElement.scrollTop = stickyScrollTop -= lastScrollTop - st
         }
      }

      lastScrollTop = st <= 0 ? 0 : st
   }
   function handleStickyScroll() {
      stickyScrollTop = stickyElement.scrollTop;
   }
   function handleMediaQuery(x) {
      if (x.matches) { // If media query matches
         window.addEventListener('scroll', handleDualScroll)

         stickyElement.addEventListener('scroll', handleStickyScroll)
      } else {
         window.removeEventListener('scroll', handleDualScroll)
         stickyElement.removeEventListener('scroll', handleStickyScroll)
      }
   }
   var x = window.matchMedia("(min-width: 992px)")
   handleMediaQuery(x);
   x.addEventListener("change", function() {
      handleMediaQuery(x);
   });
}
